import type { Dictionary } from '@/i18n'

export const SITE = {
  name: 'GMT 2027',
  themeName: 'Ekspedisi 7 Cahaya',
  url: import.meta.env.VITE_SITE_URL ?? 'https://www.gmt2027.com',
  email: 'marifindobson@gmail.com',
  instagram: {
    handle: '@astro.ipin',
    url: 'https://www.instagram.com/astro.ipin',
  },
  /** Brand artwork — a dark printed card; used for social cards, not as a UI mark. */
  socialImage: '/brand/og-gmt2027.jpg',
} as const

export const ROUTES = {
  home: '/',
  cahaya: '/cahaya',
  expedition: '/ekspedisi',
  science: '/sains',
  about: '/tentang',
  join: '/bergabung',
} as const

export interface NavItem {
  to: string
  /** Key into `dictionary.nav`. */
  labelKey: keyof Dictionary['nav']
}

export const NAV_ITEMS: NavItem[] = [
  { to: ROUTES.home, labelKey: 'home' },
  { to: ROUTES.cahaya, labelKey: 'cahaya' },
  { to: ROUTES.expedition, labelKey: 'expedition' },
  { to: ROUTES.science, labelKey: 'science' },
  { to: ROUTES.about, labelKey: 'about' },
]
